import { socket } from '../../EntryShared.ts';
import { UIRoomWarningPopupContentBase } from './UIRoomWarningPopupContentBase.ts';
export class ReadyUpExceedLimitWarningContent extends UIRoomWarningPopupContentBase {
    shouldShowWarning() {
        const userSession = this.roomState.getSessions().find((session)=>session.userSessionId == socket.controller.session.id);
        if (this.roomState.hostSession.userSessionId == socket.controller.session.id) return false;
        if (userSession === null || userSession === void 0 ? void 0 : userSession.isReadyToPlay) return false;
        return this.roomState.gameSetting.victoryPointsToWin > this.roomState.victoryPointsRecommendedLimit;
    }
    // eslint-disable-next-line class-methods-use-this
    getTitle() {
        return {
            key: 'strings:roomPage.warnings.readyUpExceedLimitWarning.title'
        };
    }
    // eslint-disable-next-line class-methods-use-this
    getDescription() {
        return {
            key: 'strings:roomPage.warnings.readyUpExceedLimitWarning.description'
        };
    }
}
